export class AppRoutes {
  static home = "/";
  static keyEvents = "/keyevents";
  static keyEventDetails = "/keyevents/:event";
  static menu = "/menu";
   static events = (event = "") => `/keyevents/${event}`;
  static  vidoesPage = `/Vidoespage/:page`;
}
